import { BehaviorSubject } from 'rxjs';
export const getCalculationReusableDocumentsStore = () => {
    const getInitialState = () => ({
        reusableDocuments: []
    });
    const calculationReusableDocumentsSubject = new BehaviorSubject(getInitialState());
    const subscribe = (callback) => calculationReusableDocumentsSubject.subscribe(callback);
    const setReusableDocuments = (reusableDocuments) => {
        calculationReusableDocumentsSubject.next({
            reusableDocuments: reusableDocuments
        });
    };
    const getReusableDocuments = () => calculationReusableDocumentsSubject.getValue().reusableDocuments;
    const reset = () => {
        calculationReusableDocumentsSubject.next(getInitialState());
    };
    return {
        getInitialState,
        subscribe,
        setReusableDocuments,
        getReusableDocuments,
        reset
    };
};
